import { LoginPageComponent } from '$pages/login/login-page.component';
import { AuthService } from '$services/auth/auth.service';
import { Component, HostBinding, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: 'app-user-connected',
  templateUrl: './user-connected.component.html',
  styleUrls: ['./user-connected.component.css']
})
export class UserConnectedComponent {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly dialog: MatDialog) { }

  @HostBinding('className') get componentClass(): string {
    const _isLogged = this.authService.isLogged();
    return _isLogged ? 'connected' : 'not-connected'
  }

  get userConnected(): boolean {
    const _isLogged = this.authService.isLogged();
    return this.authService.isLogged();
  }

  onClick(): void {
    if (!this.authService.isLogged()) {
      this.openDialog()
    } else {
      this.authService.logout();
    }
  }
  openDialog(): void {
    this.dialog
      .open(LoginPageComponent, {
        panelClass: 'login-modalbox'
      })
      .afterClosed()
      .subscribe(result => {
        console.log('The dialog was closed', result)
        this.reloadCurrentRoute()
      });
  }

  getUserDetails(){
   return this.authService.user?.email;
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => {
        this.router.navigate([currentUrl]);
      });
  }
}
